export default __webpack_public_path__ + "static/howitworks-0e44d232212de754ba8bd5db25dabfc5.png";